// Column sorting for every report table. A sort is { column, dir } with dir
// "asc" (small to large) or "desc"; null = the table's default order.
// columns: { [column id]: { value(row), first: "asc" | "desc" } }
//
// Rules (the same on every table):
// - First click on a column picks its most useful direction: big numbers
//   first, best (lowest) position or rank first, A to Z for text.
// - Clicking the same column again reverses it.
// - Blank values (null / undefined, shown as "–") always go to the bottom.
// - Ties keep the table's default order.

// The sort after clicking a column heading.
export function nextSort(current, column, columns) {
  if (current && current.column === column) {
    return { column, dir: current.dir === "asc" ? "desc" : "asc" };
  }
  return { column, dir: columns[column].first };
}

// A sorted copy of rows. defaultCompare = the table's default order.
export function sortRows(rows, sort, columns, defaultCompare) {
  if (!sort || !columns[sort.column]) return [...rows].sort(defaultCompare);
  const { value } = columns[sort.column];
  const flip = sort.dir === "desc" ? -1 : 1;
  return [...rows].sort((a, b) => {
    const va = value(a);
    const vb = value(b);
    if (va == null && vb == null) return defaultCompare(a, b);
    if (va == null) return 1;
    if (vb == null) return -1;
    const order = typeof va === "string" ? va.localeCompare(vb, "en-GB", { numeric: true }) : va - vb;
    return order * flip || defaultCompare(a, b);
  });
}

// True when a sort is the same as the default (no "Back to …" link needed).
export function isSameSort(a, b) {
  if (!a || !b) return !a && !b;
  return a.column === b.column && a.dir === b.dir;
}
